import { useMutation } from '@tanstack/react-query'

import { useAlerts } from '../../theme/hooks/useAlerts'
import { createGebiedswissel } from '../services/createGebiedswissel'

export { useCreateGebiedswissel }

const useCreateGebiedswissel = () => {
  const { successAlert } = useAlerts()

  return useMutation({
    mutationFn: createGebiedswissel,
    onSuccess: () => {
      successAlert('Gebiedswissel succesvol aangemaakt')
    },
  })
}
